import(/* webpackMode: "eager" */ "__barrel_optimize__?names=message!=!/app/node_modules/antd/es/index.js");
import(/* webpackMode: "eager" */ "/app/src/components/Other/FileUploadToLocal.tsx")